import styles from './PlateSignals.module.scss'
import { PlateRegister } from './PlateRegister'

/**
 * CARD 01 — "We analyze signals". RADIAL CONVERGENCE, then DATED.
 *
 * Five lanes bleed in from off-frame and converge on the hub; a 2px plumb line drops from the hub
 * to the day axis and lands on a lit tick. Eight ambient dots on coprime clocks are the wider
 * population.
 *
 * PHASE LOCKING WITHOUT ARITHMETIC: travel duration EQUALS the period, so a mark's arrival phase is
 * identical to its animation-delay, and the five ripples carry the same five delays — each
 * absorption pulse sits exactly on its own arrival. One landing every 0.72s.
 */
const LANES = [14, 42, 70, 98, 126]

// dx/dy end the flight at the hub (242,70); --p is the resting fraction for the stilled frame.
const FLYERS = [
  { y: 14, dy: 56, p: 0.34, delay: 0 },
  { y: 42, dy: 28, p: 0.66, delay: 0.72 },
  { y: 70, dy: 0, p: 0.2, delay: 1.44 },
  { y: 98, dy: -28, p: 0.78, delay: 2.16 },
  { y: 126, dy: -56, p: 0.48, delay: 2.88 },
]

const AMBIENT = [
  { cx: 46, cy: 16, duration: 9 },
  { cx: 126, cy: 20, duration: 7 },
  { cx: 70, cy: 118, duration: 11 },
  { cx: 150, cy: 112, duration: 8 },
  { cx: 286, cy: 30, duration: 10 },
  { cx: 330, cy: 60, duration: 7.5 },
  { cx: 300, cy: 104, duration: 12 },
  { cx: 196, cy: 126, duration: 9.5 },
]

export const PlateSignals = () => (
  <div className={styles.plate}>
    <svg viewBox="0 0 360 160" aria-hidden focusable="false">
      <g className={styles.hair}>
        {LANES.map((y) => (
          // Lanes stop at x=237 so they tuck under the hub's ring.
          <line key={y} x1="-2" y1={y} x2="237" y2="70" />
        ))}
      </g>

      {AMBIENT.map((dot) => (
        <circle
          key={`${dot.cx}-${dot.cy}`}
          className={styles.amb}
          cx={dot.cx}
          cy={dot.cy}
          r="2"
          style={{ animationDuration: `${dot.duration}s` }}
        />
      ))}

      <PlateRegister
        figure="01"
        hairClassName={styles.hair as string}
        hair2ClassName={styles.hair2 as string}
        numberClassName={styles.fno as string}
      />

      {/* dated entries; the live one is under the plumb line at tick x=242 */}
      <line className={styles.dm} x1="98" y1="134" x2="98" y2="142" />
      <line className={styles.dm} x1="170" y1="134" x2="170" y2="142" />
      <line className={`${styles.dm} ${styles.dmLive}`} x1="242" y1="134" x2="242" y2="142" />
      <line className={styles.lead} x1="242" y1="77" x2="242" y2="132" />

      {FLYERS.map((flyer) => (
        <circle
          key={`rip-${flyer.y}`}
          className={styles.rip}
          cx="242"
          cy="70"
          r="5"
          style={{ animationDelay: `${flyer.delay}s` }}
        />
      ))}

      {/* dots BEFORE the hub: the hub's white fill swallows the arriving mark. Load-bearing order. */}
      {FLYERS.map((flyer) => (
        <circle
          key={`dot-${flyer.y}`}
          className={styles.dot}
          cx="-2"
          cy={flyer.y}
          r="2.6"
          style={
            {
              '--dx': '244px',
              '--dy': `${flyer.dy}px`,
              '--p': flyer.p,
              animationDelay: `${flyer.delay}s`,
            } as React.CSSProperties
          }
        />
      ))}

      <circle className={styles.hub} cx="242" cy="70" r="5" />
    </svg>
  </div>
)
